// extracted by mini-css-extract-plugin
module.exports = {"title":"CardFrame_title__6FqRf","subtitle":"CardFrame_subtitle__WGOQt","description":"CardFrame_description__I6JFs","frame":"CardFrame_frame__jY2W6"};